import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["message"]

    show(event) {
        this.messageTarget.textContent = event.detail.message || "Action completed successfully!";
        this.element.classList.remove("hidden", "opacity-0")

        setTimeout(() => {
            this.element.classList.add("opacity-0")

            setTimeout(() => {
                this.element.classList.add("hidden")
            }, 500)
        }, 3000)
    }
}